var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OppTable',{attrs:{"heading":"Recent Opportunities","opps":_vm.opps,"show-table-header":false,"show-pagination":false,"date-label":"Created","date-field":"created_at"}})}
var staticRenderFns = []

export { render, staticRenderFns }